export default __webpack_public_path__ + "static/media/aura.9c24928b.png";